module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAXVBMVEVHcEz/gBP/ghL/Mzn/SC7/YyL/gBX/bRz/SS7/nQX/nQX/kgv/Mzj/bhz/Si3/oQP/ehb/TSz/cRv/Uin/hBH/ZSD/jQ3/lAr/ah7/XyP/QDL/WCb/MTn/Ry//ODaWrUGHAAAAEHRSTlMAudPrZX45GJv+617G6dvIWwRsjQAAAONJREFUeNqNzInOgyAQRtEPBQZ3ULTLv7z/Y9Za3IpTewiZZHIz2GkKnMuzhr6IslyfR6OTirKnnPBJcZk0+ERcXgrw9BDk4CXDjD8l/OCDhG8mr5IATVFCiQ+sHxVAklDU2Jm3IwNt7Xsl7I4X00ZgS9nWBu30xbgZn8KKqpZBm0MtZ3OqunIqzPS1ZyuNQPY8iUDdWL1BYL6KfnhLpPjmtkSy40kE5Fznus65eDqNWe04NRbyj6OwqpkmJazk/ZjEljlsDPbK/1iJdyZqDGIy/d1ROEJmkxgCR5oyTdPSyH3yAEfoN9bbtzRtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/hot.png
// module id = FWkH
// module chunks = 215